import { makeStyles, mergeClasses } from "@fluentui/react-components";

import { hiddenContentClassName } from "@1js/acui-common";
// eslint-disable-next-line no-restricted-imports
import { hiddenContentStyle } from "@1js/acui-common/lib/styling/next/commonStyles.styles";
import type { AppButtonState } from "../Next";

const useHiddenContentStyles = makeStyles({
  base: {
    [`& .${hiddenContentClassName}`]: {
      ...hiddenContentStyle,
    },
  },
  iconBefore: {
    marginRight: "0px",
  },
  iconAfter: {
    marginLeft: "0px",
  },
});

export const useCommonButtonStyles = (
  state: AppButtonState,
  iconOnly: boolean,
  hideCustomTooltipEnabled?: boolean
): AppButtonState => {
  const hiddenContentStyles = useHiddenContentStyles();
  if (hideCustomTooltipEnabled) {
    state.root.className = mergeClasses(
      iconOnly && hiddenContentStyles.base,
      state.root.className
    );

    if (state.icon) {
      state.icon.className = mergeClasses(
        iconOnly &&
          (state.iconPosition === "before"
            ? hiddenContentStyles.iconBefore
            : hiddenContentStyles.iconAfter),
        state.icon.className
      );
    }
  }
  return state;
};
